<footer>
  <div class="text-bg-navy py-4">
    <div class="container-fluid">
      <p class="small mb-2">For assistance with this product, contact 
        <a href="mailto:LabcorpPayerSupport@Labcorp.com" class="text-white"> LabcorpPayerSupport&#64;Labcorp.com</a>
      </p>
     <p class="small mb-0"
        >{{ appTitle }} v{{ appVersion }} ©{{ appYear }} Laboratory Corporation
        of America® Holdings. All Rights Reserved. Visit
        <a 
          href="https://www.labcorp.com/"
          target="_blank"
          class="text-white"
          title="Labcorp.com (Opens in a new window)"
          rel=noopener
          ><u>labcorp.com</u></a>
        |
        <a
          href="https://www.labcorp.com/hipaa-privacy"
          target="_blank"
          class="text-white"
          title="Labcorp Privacy Statement (Opens in a new window)" rel=noopener
          ><u>Privacy Statement</u></a> | <a class="ot-sdk-show-settings"
          style="cursor:pointer; color:#FFFFFF">Do Not Sell or Share My Personal Information</a>
    </p>
    </div>
  </div>
</footer>
